var map = {
	"./star1.png": "f01a",
	"./star1_sm.png": "132d",
	"./star2.png": "fa75",
	"./star2_sm.png": "c31e",
	"./star3.png": "93f0",
	"./star3_sm.png": "bd90",
	"./star4.png": "79c3",
	"./star4_sm.png": "1bb0",
	"./stars.png": "d0a9",
	"./stars_sm.png": "1fc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3813";